// extracted by mini-css-extract-plugin
module.exports = {"extension-table":"extensions-info_component_extension-table__U_EnK"};